<template>
	<div class="ma-2">
		<div v-for="(categoria, c) in datos" :key="'r-' + c">
			<h3 class="text-center text-uppercase">{{ categoria.titulo }}</h3>
			<div>
				<v-container fluid>
					<v-row dense>
						<v-col
							xs="12"
							sm="6"
							lg="4"
							cols="12"
							v-for="(recurso, r) in categoria.recursos"
							:key="'c-' + r"
						>
							<v-card :color="r % 2 ? 'info' : 'primary'" dark>
								<v-card-title class="headline word">{{
									recurso.titulo
								}}</v-card-title>

								<v-card-actions>
									<v-btn text :href="recurso.link">Ver más</v-btn>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

		<br /><v-btn
			block
			color="primary"
			class="text-center"
			max-width="98%"
			href="https://www.ucab.edu.ve/guia_contingencia_academica_2020/"
			>VER MÁS GUÍAS
		</v-btn>

		<br />
	</div>
</template>

<script>
export default {
	data() {
		return {
			datos: [
				{
					titulo: "Normas Generales",
					recursos: [
						{
							titulo: "Reprogramación de calendario académico 2019 – 2020",
							link:
								"https://www.ucab.edu.ve/wp-content/uploads/sites/2/2020/04/Resoluci%C3%B3n-01-07.04.2020-1.pdf"
						},
						{
							titulo: "Desarrollo de las actividades académicas durante el semestre",
							link:
								"https://www.ucab.edu.ve/wp-content/uploads/sites/2/2020/04/Resoluci%C3%B3n-02-07.04.2020-def.pdf"
						}
					]
				},
				{
					titulo: "Recursos",
					recursos: [
						{
							titulo: "¿Cómo configurar tu correo UCAB en tu teléfono Android?",
							link:
								"https://drive.google.com/file/d/1cBJNLqYN6qCUMROIWIkxFgkJRbB_lWHN/view"
						},
						{
							titulo: "Centro de Ayuda UCAB",
							link: "https://ucab.freshdesk.com/support/home"
						},
						{
							titulo: "Crear tu cuenta en Office 365",
							link:
								"https://drive.google.com/file/d/1xsNt644OyoPBEXZpa3YpylBz0JedheE0/view"
						},
						{
							titulo: "Estudia de forma colaborativa con Google y tu cuenta UCAB",
							link:
								"https://drive.google.com/file/d/17jgwEffns8zzIugrFuY9q4u5g1sQv7T2/view"
						},
						{
							titulo: "Guia de Zoom como participante",
							link:
								"https://drive.google.com/file/d/16FqZNw0rluRwz_zC-sVmNvIhKGe-haj0/view"
						}
					]
				}
			]
		};
	}
};
</script>

<style>
.word {
	word-break: break-word;
}
</style>
